import React from "react";
import "./floating.css";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/+8619540597714" // ضع رقمك هنا مع كود الدولة
      className="floating-chat floating-chat--whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
    >
      <i className="fab fa-whatsapp" aria-hidden="true"></i>
    </a>
  );
}
